// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"LeaderboardsPage_pageContainer__1-7oR","icons":"LeaderboardsPage_icons__gTjzb","emptyContainer":"LeaderboardsPage_emptyContainer__2vt-c"};